export default "__VITE_ASSET__CwoUTKBj__"